import { useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "../state/questionnaireReducerAtom";
import { shallowEqual } from "../../../utils/shallowEqual";

/**
 * Get all visibility states. Re-renders on any visibility change.
 *
 * @example const visibility = useVisibilityMap();
 * @see useVisibility - single question (better performance)
 */
const visibilityMapAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.visibility ?? {},
  shallowEqual,
);

export function useVisibilityMap(): Record<string, boolean> {
  return useAtomValue(visibilityMapAtom);
}
